/**
 * @generated SignedSource<<f43786c95d21554e6525e62ba3fbbd95>>
 * @relayHash 34217eab0f370d5568f7c0ae333e556f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1b22a744e4afb7fe2f6980e1e86b1c0648005cad43d16555b8e2f7003e74dec9

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type SandboxEchoPageQuery$variables = {
  cloudId: string;
  enableDefer: boolean;
  skipLongQuery: boolean;
};
export type SandboxEchoPageQuery$data = {
  readonly jira: {
    readonly criticalMessage: string | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"SandboxEchoDefer1" | "SandboxEchoDefer2" | "SandboxEchoDefer3" | "SandboxEchoVeryLongQuery">;
  };
};
export type SandboxEchoPageQuery = {
  response: SandboxEchoPageQuery$data;
  variables: SandboxEchoPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "enableDefer"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skipLongQuery"
  }
],
v1 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v2 = [
  (v1/*: any*/)
],
v3 = {
  "alias": "criticalMessage",
  "args": (v2/*: any*/),
  "kind": "ScalarField",
  "name": "echo"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "SandboxEchoPageQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            {
              "kind": "Defer",
              "selections": [
                {
                  "args": (v2/*: any*/),
                  "kind": "FragmentSpread",
                  "name": "SandboxEchoDefer1"
                }
              ]
            },
            {
              "kind": "Defer",
              "selections": [
                {
                  "args": (v2/*: any*/),
                  "kind": "FragmentSpread",
                  "name": "SandboxEchoDefer2"
                }
              ]
            },
            {
              "kind": "Defer",
              "selections": [
                {
                  "args": [
                    (v1/*: any*/),
                    {
                      "kind": "Variable",
                      "name": "enableDefer",
                      "variableName": "enableDefer"
                    }
                  ],
                  "kind": "FragmentSpread",
                  "name": "SandboxEchoDefer3"
                }
              ]
            },
            {
              "condition": "skipLongQuery",
              "kind": "Condition",
              "passingValue": false,
              "selections": [
                {
                  "kind": "Defer",
                  "selections": [
                    {
                      "args": (v2/*: any*/),
                      "kind": "FragmentSpread",
                      "name": "SandboxEchoVeryLongQuery"
                    }
                  ]
                }
              ]
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SandboxEchoPageQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "if": "enableDefer",
            "kind": "Defer",
            "label": "SandboxEchoPageQuery$defer$SandboxEchoDefer1_PVNZy",
            "selections": [
              {
                "alias": "defer1",
                "args": [
                  (v1/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "where",
                    "value": {
                      "delayMs": 500
                    }
                  }
                ],
                "kind": "ScalarField",
                "name": "echo"
              }
            ]
          },
          {
            "if": "enableDefer",
            "kind": "Defer",
            "label": "SandboxEchoPageQuery$defer$SandboxEchoDefer2_PVNZy",
            "selections": [
              {
                "alias": "defer2",
                "args": [
                  (v1/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "where",
                    "value": {
                      "delayMs": 700
                    }
                  }
                ],
                "kind": "ScalarField",
                "name": "echo"
              }
            ]
          },
          {
            "if": "enableDefer",
            "kind": "Defer",
            "label": "SandboxEchoPageQuery$defer$SandboxEchoDefer3_1jcU60",
            "selections": [
              {
                "alias": "defer3",
                "args": [
                  (v1/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "where",
                    "value": {
                      "delayMs": 900
                    }
                  }
                ],
                "kind": "ScalarField",
                "name": "echo"
              },
              {
                "if": "enableDefer",
                "kind": "Defer",
                "label": "SandboxEchoDefer3$defer$SandboxEchoNestedDefer_PVNZy",
                "selections": [
                  {
                    "alias": "nestedImmediate",
                    "args": [
                      (v1/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "where",
                        "value": {
                          "delayMs": 1
                        }
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "echo"
                  },
                  {
                    "alias": "nestedDefer1",
                    "args": [
                      (v1/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "where",
                        "value": {
                          "delayMs": 600
                        }
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "echo"
                  },
                  {
                    "alias": "nestedDefer2",
                    "args": [
                      (v1/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "where",
                        "value": {
                          "delayMs": 1600
                        }
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "echo"
                  }
                ]
              }
            ]
          },
          {
            "condition": "skipLongQuery",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "if": "enableDefer",
                "kind": "Defer",
                "label": "SandboxEchoPageQuery$defer$SandboxEchoVeryLongQuery_PVNZy",
                "selections": [
                  {
                    "alias": "wasItWorthTheWait",
                    "args": [
                      (v1/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "where",
                        "value": {
                          "delayMs": 5000
                        }
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "echo"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "1b22a744e4afb7fe2f6980e1e86b1c0648005cad43d16555b8e2f7003e74dec9",
    "metadata": {},
    "name": "SandboxEchoPageQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "6c4aa6e81890a1b652ce97e525a243a3";

export default node;
